import { render, staticRenderFns } from "./appAdminBatch.vue?vue&type=template&id=55c2a700&scoped=true"
import script from "./appAdminBatch.vue?vue&type=script&lang=js"
export * from "./appAdminBatch.vue?vue&type=script&lang=js"
import style0 from "./appAdminBatch.vue?vue&type=style&index=0&id=55c2a700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2a700",
  null
  
)

export default component.exports